import React, { useState } from 'react'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Paper, Tooltip, Typography } from '@mui/material'
import OpenInFull from '@mui/icons-material/OpenInFull'
import Close from '@mui/icons-material/Close'

// Inline chart SVGs leave a baseline gap that would trigger a needless scrollbar
const BODY_SX = { flex: 1, minHeight: 0, overflowY: 'auto', '& svg.recharts-surface': { display: 'block' } }

// A card that fills its grid cell; the body scrolls when content is taller than the card.
// With a title it can be maximised into a large dialog, where fill-height charts stretch.
export default function Panel({ title, action, children, sx, bodySx, expandable = true }) {
  const [expanded, setExpanded] = useState(false)
  const canExpand = expandable && Boolean(title)

  return (
    <>
      <Paper
        variant="outlined"
        sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0, boxSizing: 'border-box', ...sx }}
      >
        {(title || action) && (
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} flexShrink={0} gap={1}>
            {title && <Typography variant="subtitle1">{title}</Typography>}
            <Box display="flex" alignItems="center" gap={0.5} ml="auto">
              {action}
              {canExpand && (
                <Tooltip title="Maximise">
                  <IconButton size="small" aria-label={`Maximise ${title}`} onClick={() => setExpanded(true)}>
                    <OpenInFull fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Box>
        )}
        <Box sx={{ ...BODY_SX, ...bodySx }}>{children}</Box>
      </Paper>

      {canExpand && (
        <Dialog
          open={expanded}
          onClose={() => setExpanded(false)}
          fullWidth
          maxWidth="xl"
          PaperProps={{ sx: { height: '90vh' } }}
        >
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" component="span">{title}</Typography>
            <Box ml="auto" display="flex" alignItems="center" gap={0.5}>
              {action}
              <IconButton aria-label="Close" onClick={() => setExpanded(false)}>
                <Close />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
            {expanded && <Box sx={BODY_SX}>{children}</Box>}
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}
